import RenewPresentationComponent from "./RenewPresentationComponent";

export default RenewPresentationComponent;